import { createAsyncThunk } from '@reduxjs/toolkit';

import { journeyAPI } from '@/modules/journey/api';
import { namespace } from '@/modules/journey/namespace';

import { setJourneys } from '../actions';

const loadJourneys = createAsyncThunk(
  `${namespace}/load-journeys`,
  async (
    {
      limit,
      offset,
      driverId,
      from,
      to,
      number,
    }: {
      limit: number;
      offset: number;
      driverId?: string;
      from?: string;
      to?: string;
      number?: string;
    },
    { dispatch },
  ) => {
    const journeys = await journeyAPI.fetchJourneys({ limit, offset, driverId, from, to, number });

    dispatch(setJourneys(journeys));

    return journeys;
  },
);

export { loadJourneys };
